import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";

const SystemStatus = () => {
  const form = document.getElementById("modify_system_status_form");
  if (form) {
    let toggle = document.querySelector('input[name="status"]');
    let label = toggle.parentElement.querySelector("span");

    let spinner = document.getElementById('statusSpinner');

    toggle.addEventListener("change", (event) => {
      event.target.value = event.target.checked ? 1 : 0;
      form.dispatchEvent(new SubmitEvent("submit")); // important for ajax as .submit() has no event!
      spinner.classList.remove('hidden');
      toggle.disabled = true;
    });

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();
      const data = new FormData(form);
      data.append("action", "modify_system_status");
      //console.log([...data]);
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          spinner.classList.add('hidden');
           toggle.disabled = false;
          createToast({
            type: "success",
            message: result.message,
            duration: 1000,
            url: null,
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          createToast({
            type: "error",
            message: "System Error!",
            duration: 1000,
          });
        });
    });
  }
};

export { SystemStatus };
